import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import hasIn from 'lodash/hasIn';
import isEmpty from 'lodash/isEmpty';
import isEmail from 'validator/lib/isEmail';
import isString from 'lodash/isString';
import InputField from './InputField';
import SelectField from './SelectField';
import Button from './Button';
import { signUp } from '../actions';
import { cityOptions, daysOptions, groupOptions } from '../data';

const daysOptionsStringValues = daysOptions.map(option => {
  return {
    label: option.label,
    value: option.value.toString()
  }
});

const initialValues = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  confirmPassword: '',
  city: '',
  eventDay: '',
  group: '',
};

class SignUp extends Component {
  static validate(values) {
    const errors = {};

    const requiredFields = [
      'email',
      'password',
      'firstName',
      'lastName',
      'password',
      'confirmPassword',
      'city',
      'eventDay',
      'group',
    ];
    requiredFields.forEach((field) => {
      if (!hasIn(values, field) || isEmpty(values[field])) {
        errors[field] = 'This is required.';
      }
    });

    if (!isEmpty(values.password) && values.password.length < 6) {
      errors.password = 'Password must be at least 6 characters long.'
    }

    // Verify that password and confirmPassword match
    if (
      !isEmpty(values.password)
      && !isEmpty(values.confirmPassword)
      && values.password !== values.confirmPassword
    ) {
      errors.confirmPassword = 'Passwords must match.';
    }

    if (!isEmpty(values, 'email') && isString(values.email) && !isEmail(values.email)) {
      errors.email = 'Email address must be a valid email address.';
    }

    return errors;
  }

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values) {
    const { dispatch } = this.props;
    return dispatch(signUp(values))
      .then(response => {
        console.log(response)
      })
  }

  render() {
    const { loggedIn } = this.props;

    if (loggedIn) {
      return <Redirect to="/quiz" />;
    }

    return (
      <Form
        onSubmit={this.onSubmit}
        initialValues={initialValues}
        validate={SignUp.validate}
      >
        {({
          handleSubmit, submitting, submitSucceeded, submitFailed,
        }) => (
          <div>
            {submitSucceeded && (
              <span className="submitSuccessMsg f6 correct">One second while we set up your account for the challenge.</span>
            )}
            {submitFailed && (
            <span className="submitErrorMsg f6 incorrect">Great Scott! You forgot to fill out or select an item below. Take a look, and try again. Trouble? help@autoevents.io</span>
            )}
            <form onSubmit={handleSubmit}>
              <InputField disabled={submitting} name="firstName" label="First Name" />
              <InputField disabled={submitting} name="lastName" label="Last Name" />
              <InputField disabled={submitting} name="email" label="Email Address" />
              <InputField disabled={submitting} type="password" name="password" label="Password" />
              <InputField disabled={submitting} type="password" name="confirmPassword" label="Confirm Password" />
              <SelectField options={cityOptions} disabled={submitting} name="city" label="City" />
              <SelectField options={daysOptionsStringValues} disabled={submitting} name="eventDay" label="Event Day" />
              <SelectField options={groupOptions} disabled={submitting} name="group" label="Group" />
              <div className="pt4">
                <Button disabled={submitting} type="submit">Sign Up</Button>
              </div>
            </form>
          </div>
        )}
      </Form>
    );
  }
}

SignUp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    loggedIn: state.loggedIn,
  };
}

export default connect(mapStateToProps)(SignUp);



// WEBPACK FOOTER //
// ./src/components/SignUp.js